import React, {useState, useRef} from 'react';
import { Modal as ModalComponent, closeModal } from '../../common/Modal.jsx';
import Errors from '../../common/Errors.jsx';
import { Portal } from "../../common/Portal.jsx";

import { project_report_update_selected_optional_forms_path } from '~/routes';

const MODAL_ID = 'choose-optional-forms-modal';

export const ChooseOptionalFormsModal = ({handleCloseModal, project_report_id, monitoring_report_id, forms, selectedOptionalFormIds, setSelectedOptionalFormIds, editUrl = null}) => {
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState([]);
  const formRef = useRef();

  const mandatoryForms = forms.filter(p => p.required);
  const optionalForms = forms.filter(p => !p.required);

  const handleClose = () => {
    closeModal(MODAL_ID);
    handleCloseModal();
  };

  const submit = (e) => {
    e.preventDefault();
    setSaving(true);

    const project_id = $('#report-container').data('project-id');
    const url = project_report_update_selected_optional_forms_path({project_id: project_id, project_report_id: project_report_id, report_id: monitoring_report_id});

    jQuery.post(url, jQuery(formRef.current).serialize())
      .done((res) => {
        setSelectedOptionalFormIds(res.selected_optional_form_ids);
        setErrors([]);
        handleClose();

        if (editUrl != null) {
          $('.container-fluid:last').html(SmartME.loadingIndicator());
          window.location = editUrl;
        }
      })
      .fail((res) => {
        let responseJSON = res.responseJSON ? res.responseJSON.errors : {server: [{message: I18n.t('unexpected_error')}]};
        setErrors(responseJSON);
      });

    setSaving(false);
  };

  return (
    <Portal
      id={MODAL_ID}
      size='md'
      title={I18n.t('choose_forms')}
      onClose={handleClose}
      cancelLabel={I18n.t('close')}
      onSave={submit}
      saving={saving}
      component={ModalComponent}
    >
      <div className="form-group">
        <Errors errors={errors}/>

        {mandatoryForms.map((v, idx) => (
          <div className='form-check' key={`forms-${idx}`}>
            <input
              type='checkbox'
              defaultChecked={true}
              className='form-check-label'
              disabled
            /> <label className='form-check-label'> {v['name'][I18n.locale]}</label> ({I18n.t('mandatory')})
          </div>
        ))}

        <form ref={formRef} onSubmit={submit}>
          <input type='hidden' name='project_report[selected_optional_form_ids][]' defaultValue='' />

          {optionalForms.map((v, idx) => (
            <div className='form-check' key={`optionalForms-${idx}`}>
              <input
                type='checkbox'
                name='project_report[selected_optional_form_ids][]'
                defaultChecked={selectedOptionalFormIds.indexOf(v['programme_form_link_id']) >= 0}
                value={v['programme_form_link_id']}
                className='form-check-label'
              /> <label className='form-check-label'> {v['name'][I18n.locale]}</label> ({I18n.t('optional')})
            </div>
          ))}
        </form>
      </div>
    </Portal>
  );
};

const OptionalFormsButton = ({project_report_id, monitoring_report_id, forms, selectedOptionalFormIds = [], setSelectedOptionalFormIds}) => {
  const [openModal, setOpenModal] = useState(false);

  // handle onClose event of the modal
  const handleCloseModal = () => setOpenModal(false);

  // handle onClick event of the dropdown
  const handleClick = () => setOpenModal(true);

  return (<>
    <button
      type='button'
      className='btn btn-link p-0'
      onClick={handleClick}>{`+ ${I18n.t('choose_forms')}`}
    </button>

    {openModal && <ChooseOptionalFormsModal {...{handleCloseModal, project_report_id, monitoring_report_id, forms, selectedOptionalFormIds, setSelectedOptionalFormIds}}></ChooseOptionalFormsModal>}
  </>);
};

export default OptionalFormsButton;
